export const historyStorageKey = '@doris:tryon_history'
